import React from 'react';

import EmailLeadCapture from '@components/EmailLeadCapture';
import useWindowSize from '@hooks/useWindowSize';
import { Theme } from '@interfaces/global';
import { READER_URL } from '@src/env';
import { WIDTH_SM } from '@utils/constants';
import { FormLocation } from '@utils/enums';
import { LeadType } from '@utils/types';

import { ModalType } from '../Content/MarketingCopy';

export interface LeadCaptureModalBodyProps {
  articleId?: number;
  articleSlugs?: string[];
  articleTitleSection?: string;
  briefingGuid?: string;
  buttonText: string;
  customUrl?: string;
  imgPathLarge?: string;
  imgPathMedium?: string;
  imgPathSmall?: string;
  isPro?: boolean;
  isVertical?: boolean;
  includeSignInOption?: boolean;
  leadButtonText?: string;
  leadType: LeadType;
  gdpr?: boolean;
  newsletterId?: number;
  newsletterIds?: number[];
  modalType?: ModalType;
  modalId?: string;
  offerCode?: string;
  offerLink: string;
  shareGuid?: string;
  theme?: Theme;
  unlockContent?: boolean;
  withOauth?: boolean;
  emailLeadCaptureClassName?: string;
  proOfferCode?: string;
  annualOfferCode?: string;
  newsletterImageUrl?: string;
}

const HTTP = 'http';

const LeadCaptureModalBody = ({
  articleId,
  briefingGuid,
  buttonText,
  customUrl,
  emailLeadCaptureClassName = '',
  gdpr,
  includeSignInOption = true,
  isPro,
  leadType,
  newsletterId,
  offerLink,
  shareGuid,
  theme = Theme.Dark,
  unlockContent,
  withOauth = true,
}: LeadCaptureModalBodyProps) => {
  const redirectToOnSuccess =
    customUrl?.length > 0
      ? customUrl
      : offerLink.includes(HTTP)
      ? offerLink
      : `${READER_URL}/${offerLink}`;
  const { width: windowWidth } = useWindowSize();

  return (
    <div className={emailLeadCaptureClassName}>
      <EmailLeadCapture
        articleId={articleId}
        buttonClassName="w-full sm:w-auto"
        buttonText={buttonText}
        briefingGuid={briefingGuid}
        formLocation={FormLocation.MarketingModal}
        includeSignInOption={includeSignInOption}
        inputClassName="w-full dark:bg-[var(--light-grayscale-charcoal)]"
        isVertical={windowWidth < WIDTH_SM}
        leadType={leadType}
        gdpr={gdpr}
        redirectToOnSuccess={redirectToOnSuccess}
        oauthButtonsClassName={windowWidth > WIDTH_SM ? '!mt-8' : ''}
        shareGuid={shareGuid}
        signInOptionClass="text-center sm:text-left"
        gdprClassName="mb-16"
        theme={theme}
        unlockContent={unlockContent}
        newsletterIds={newsletterId ? [newsletterId] : []}
        withOauth={withOauth}
        oauthRedirectToOnSuccess={redirectToOnSuccess}
        isPro={isPro}
      />
    </div>
  );
};

export default LeadCaptureModalBody;
